<template>
    <div class="container">
        <div class="p-3">
            <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>
            <div v-if="!loading">
                <div v-if="!isAuthorized" class="notification is-danger is-light">
                    You are not authorized to view this trip.
                </div>
                <div v-else>
                    <div class="mb-5">
                        <router-link to="/planned-trips" class="has-text-weight-bold">Trips</router-link>
                        >
                        <router-link :to="{
                            name: 'trip-detail',
                            params: {
                                recordLocator: this.recordLocator,
                                ...(this.submitted ? {} : { tripProp: trip }),
                            },
                        }" class="">Trip Details</router-link>
                        >
                        <span class="has-text-weight-light">Cancel Trip</span>
                    </div>
                    <b-icon icon="arrow_left" size=""></b-icon>
                    <div class="box mb-5 p-5" v-if="!submitted">
                        <div class="columns">
                            <div class="column is-two-thirds">
                                <!-- Select Segments -->
                                <CancellationSelect v-if="trip && segmentSelection" :trip="trip"
                                    :preSelectedSegment="getPreSelectedSegment" :activeTripSegments="activeTripSegments"
                                    @pushToConfirm="pushToConfirm" @resetPreSelectedSegment="resetPreSelected = true" />
                                <!-- /Select Segments -->
                                <!-- Confirm Cancel -->
                                <div v-if="!segmentSelection && !submitted">
                                    <div class="columns is-vcentered">
                                        <div class="column">
                                            <p class="my-2 is-size-5">Review and confirm your cancellation.</p>
                                        </div>
                                    </div>
                                    <!-- Flight Section -->
                                    <div v-if="selectedAirSegments.length > 0">
                                        <div v-for="(tst, tstIndex) in selectedAirTsts" :key="tstIndex"
                                            :class="['type-panel', 'mb-4', { 'isSelected': isTstSelected(tst) }]">
                                            <div class="section-title is-size-6 has-text-weight-medium">
                                                <div class="columns is-mobile is-vcentered">
                                                    <div class="column">
                                                        {{ $helpers.tstTitle(tst) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-body panel-block is-block">
                                                <div class="mb-4">
                                                    <div class="columns is-vcentered">
                                                        <div class="column">
                                                            <NDCTag v-if="trip.isNdcBooking" class="mb-5"
                                                                position="is-right">
                                                            </NDCTag>
                                                            <div>
                                                                <div v-for="(journey, journeyIndex) in tst.journeys"
                                                                    :key="journeyIndex" class="journey-segment">
                                                                    <div v-for="(segment, index) in journey.segments"
                                                                        :key="index">
                                                                        <ActiveAirSegment :segment="segment" />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="columns is-mobile is-multiline ticket-pricing-container">
                                                                    <!-- Ticket Number -->
                                                                    <div class="column is-half ticket-number">
                                                                        Ticket #:
                                                                        <span v-if="tst.ticketNumber">{{
                                                                            tst.ticketNumber
                                                                            }}</span>
                                                                        <span v-else
                                                                            class="has-text-weight-medium">Ticket
                                                                            Pending</span>
                                                                    </div>

                                                                    <!-- Pricing -->
                                                                    <div class="column is-half has-text-right pricing">
                                                                        Estimated Total: {{ tst.fare.total |
                                                                            formatPriceFromAmount(2, tst.fare.currency) }}
                                                                        <span class="has-text-grey is-block">
                                                                            ({{ tst.fare.base |
                                                                            formatPriceFromAmount(2, tst.fare.currency) }}
                                                                            plus tax)
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-body panel-block is-block">

                                                <div class="is-size-6 mb-4 has-text-weight-semibold">
                                                    Flight Cancellation Policy:
                                                </div>
                                                <div>
                                                    <CancelAirNotification :tst="tst" :tickets="tripTickets" />
                                                </div>

                                            </div>
                                            <div class="section-body panel-block">
                                                <b-checkbox @input="toggleTstSegments($event, tst.segments)">
                                                    I acknowledge that I have reviewed and wish to proceed with the
                                                    cancellation.
                                                </b-checkbox>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- /Flight Section -->
                                    <!-- Hotel Section -->
                                    <div v-if="selectedHotelSegments.length > 0">
                                        <div v-for="(segment, index) in selectedHotelSegments" :key="index"
                                            :class="['type-panel', 'mb-4', { 'isSelected': isSegmentSelected(segment) }]">
                                            <div class="section-title is-size-6 has-text-weight-medium">
                                                <div class="columns is-mobile is-vcentered">
                                                    <div class="column">
                                                        {{ $helpers.segmentTitle(segment) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-body panel-block is-block">
                                                <div class="mb-4">
                                                    <div class="columns is-vcentered">
                                                        <div class="column">
                                                            <div>
                                                                <ActiveHotelSegment :segment="segment" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-body panel-block is-block" v-if="getCxlPolicy(segment)">

                                                <div class="is-size-6 mb-4 has-text-weight-semibold">
                                                    Hotel Cancellation Policy:
                                                </div>
                                                <div>
                                                    <CancelDetail :pnrCxlText="segment.cxlPolicy"
                                                        :cancelPolicy="getCxlPolicy(segment)" maxWidth="100%"
                                                        headingSize="is-size-6" />
                                                    <CancelHotelNotification :cancelPolicy="getCxlPolicy(segment)"
                                                        maxWidth="100%" />
                                                </div>
                                            </div>
                                            <div class="section-body panel-block">
                                                <b-checkbox v-model="segmentsToCancel" :native-value="segment">I
                                                    acknowledge
                                                    that I have reviewed and wish to proceed with the cancellation.
                                                </b-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /Hotel Section -->
                                    <!-- Car Section -->
                                    <div v-if="selectedCarSegments.length > 0">
                                        <div v-for="(segment, index) in selectedCarSegments" :key="index"
                                            :class="['type-panel', 'mb-4', { 'isSelected': isSegmentSelected(segment) }]">
                                            <div class="section-title is-size-6 has-text-weight-medium">
                                                <div class="columns is-mobile is-vcentered">
                                                    <div class="column">
                                                        {{ $helpers.segmentTitle(segment) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-body panel-block is-block">
                                                <div class="mb-4">
                                                    <div class="columns is-vcentered">
                                                        <div class="column">
                                                            <ActiveCarSegment :segment="segment" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-body panel-block">
                                                <b-checkbox v-model="segmentsToCancel" :native-value="segment">I
                                                    acknowledge
                                                    that I have reviewed and wish to proceed with the cancellation.
                                                </b-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /Car Section -->
                                    <div class="columns">
                                        <div class="column is-flex is-justify-content-flex-end">
                                            <b-button type="is-light" @click="goBack" class="mr-2">
                                                Go Back
                                            </b-button>
                                            <b-button type="is-primary" @click="confirm"
                                                :disabled="segmentsToCancel.length !== selectedSegments.length">
                                                Confirm
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                                <!-- /Confirm Cancel-->
                            </div>
                            <div class="column">
                                <TripSummary :trip="trip" v-if="trip" />
                            </div>
                        </div>
                    </div>
                    <CancellationStatus v-if="submitted && cancellationResponse" :response="cancellationResponse" />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import ActiveAirSegment from "../components/Trip/Cancellation/ActiveAirSegment.vue";
import NDCTag from "@/components/Tags/NDCTag.vue";
import ActiveCarSegment from "@/components/Trip/Cancellation/ActiveCarSegment.vue";
import ActiveHotelSegment from "@/components/Trip/Cancellation/ActiveHotelSegment.vue";
import CancelDetail from "../components/Trip/Cancellation/CancelDetail.vue";
import CancelAirNotification from "../components/Trip/Cancellation/CancelAirNotification.vue";
import CancelHotelNotification from "../components/Trip/Cancellation/CancelHotelNotification.vue";
import CancellationStatus from "../components/Trip/Cancellation/CancellationStatus.vue";
import TripSummary from "@/components/Trip/TripSummary.vue";
import CancellationSelect from "@/components/Trip/Cancellation/CancellationSelect.vue";
import CancelConfirmModal from "../components/Trip/Cancellation/CancelConfirmModal.vue";
export default {
    name: "TripCancel",
    components: {
        ActiveAirSegment,
        ActiveCarSegment,
        ActiveHotelSegment,
        CancelDetail,
        CancelAirNotification,
        CancelHotelNotification,
        CancellationStatus,
        CancellationSelect,
        NDCTag,
        TripSummary
    },
    props: {
        recordLocatorHash: {
            required: true,
            type: String,
        },
        tripProp: {
            required: false,
        },
        preSelectedSegment: {
            required: false,
            default: null,
        }
    },
    data() {
        return {
            trip: null,
            loading: false,
            hotelReservationDetails: [],
            selectedSegments: [],
            selectedAirSegments: [],
            selectedCarSegments: [],
            selectedHotelSegments: [],
            selectedAirTsts: [],
            segmentsToCancel: [],
            airTstsToCancel: [],
            segmentSelection: true,
            submitted: false,
            cancellationResponse: null,
            resetPreSelected: false
        };
    },
    methods: {
        async getTrip() {
            var post = {
                meta: {
                    stateful: true,
                    sessionKey: null,
                    normalizeResponse: true,
                },
                recordLocator: this.recordLocator,
                officeId: this.$globals.profile.officeId,
            };

            let result = await this.$app.huddleLabsServerCall("amadeus/trips/show", post);
            return result;
        },
        async init() {
            let result = await this.getTrip();
            this.trip = result.data;
        },
        pushToConfirm(selectedArr) {
            this.selectedSegments = selectedArr;
            this.selectedCarSegments = selectedArr.filter(segment => segment.type === 'car');
            this.selectedHotelSegments = selectedArr.filter(segment => segment.type === 'hotel');
            this.selectedAirSegments = selectedArr.filter(segment => segment.type === 'air');
            this.segmentSelection = false;
            this.scrollToTop();

        },
        goBack() {
            this.segmentSelection = true;
            this.segmentsToCancel = [];
            this.airTstsToCancel = [];
            this.scrollToTop();
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        buildCancelRequest() {

            const airSegments = this.airTstsToCancel.length > 0
                ? this.airTstsToCancel.map(tst => tst.map(segment => segment.tattoo))
                : null;
            const carSegments = this.selectedCarSegments.length > 0
                ? this.selectedCarSegments.map(segment => segment.tattoo)
                : null;
            const hotelSegments = this.selectedHotelSegments.length > 0
                ? this.selectedHotelSegments.map(segment => segment.tattoo)
                : null;

            const allSegments = this.segmentsToCancel.map(segment => segment.tattoo);

            return {
                recordLocator: this.recordLocator,
                segments: allSegments,
                requester: this.travellerProfile.email,
                cancellationKey: this.$helpers.randomString(10),
                airTattoos: airSegments,
                carTattoos: carSegments,
                hotelTattoos: hotelSegments,
                officeId: this.$globals.profile.officeId,
            };

        },
        confirm() {

            //Build payload
            const payload = this.buildCancelRequest();

            this.openConfirmModal(payload);
        },
        generateSelectedAirTsts() {
            this.selectedAirTsts = [];

            this.trip.tstInfo.forEach(tst => {
                // Find segments that are both in tst.segments and selectedAirSegments
                const matchedSegments = tst.segments.filter(segment =>
                    this.selectedAirSegments.includes(segment)
                );

                // If there are matched segments, create a new object for selectedAirTsts
                if (matchedSegments.length > 0) {
                    this.selectedAirTsts.push({
                        ...tst,
                        segments: matchedSegments
                    });
                }
            });
        },
        toggleTstSegments(isChecked, segments) {
            if (isChecked) {
                // If checkbox is checked, add all segments
                this.segmentsToCancel.push(...segments);
                this.airTstsToCancel.push(segments)
            } else {
                // If checkbox is unchecked, remove all segments
                this.segmentsToCancel = this.segmentsToCancel.filter(
                    selectedSegment => !segments.includes(selectedSegment)
                );
                this.airTstsToCancel = this.airTstsToCancel.filter(
                    tst => tst !== segments // Compare the array itself
                );
            }
        },
        async getHotelReservationDetails() {
            for (const segment of this.activeTripSegments) {
                if (segment.type === 'hotel') {
                    // Prepare the POST request payload
                    const post = {
                        stateful: true,
                        sessionKey: null,
                        normalizeResponse: true,
                        recordLocator: this.recordLocator,
                        segmentTattoo: segment.tattoo,
                        officeId: this.$globals.profile.officeId,
                    };

                    try {
                        let result = await this.$app.huddleLabsServerCall(
                            "amadeus/hotel/pnr-reservation-details",
                            post
                        );
                        let data = result.data;
                        const details = {
                            tattoo: segment.tattoo,
                            ...data.reservationDetails,
                        };
                        this.hotelReservationDetails.push(details);
                    } catch (error) {
                        console.error(`Failed to get hotel details for segment ${segment.tattoo}:`, error);
                    }
                }
            }

            return this.hotelReservationDetails;
        },
        getCxlPolicy(segment) {
            const res = this.hotelReservationDetails.find(detail => detail.tattoo === segment.tattoo);
            if (!res) return null;
            return res.cancellationPolicies;
        },
        openConfirmModal(payload) {

            this.$buefy.modal.open({
                parent: this,
                component: CancelConfirmModal,
                hasModalCard: true,
                customClass: "",
                trapFocus: true,
                props: {
                    cancelTripPayload: payload,
                    trip: this.trip,
                    activeTripSegments: this.activeTripSegments,
                    tstInfo: this.trip.tstInfo,
                },
                events: {
                    complete: (result) => {
                        this.submitted = true;
                        this.cancellationResponse = result;

                    },
                },
            });
        },
        isSegmentSelected(segment) {
            return this.segmentsToCancel.includes(segment); // Check if the segment is selected
        },
        isTstSelected(tst) {
            const tstSegs = tst.segments;
            return tstSegs.every(segment => this.segmentsToCancel.includes(segment));
        }

    },
    watch: {
        async $route(to, from) {
            this.loading = true;
            await this.init();
            this.loading = false;
        },
        selectedAirSegments() {
            this.generateSelectedAirTsts();
        }

    },
    async mounted() {
        this.loading = true;
        if (this.tripProp && typeof this.tripProp === "object") {
            this.trip = this.tripProp;
        } else {
            await this.init();
        }

        if (this.typeList.includes('hotel')) {
            await Promise.all([
                this.getHotelReservationDetails()
            ]);
        }
        this.loading = false;
    },
    computed: {
        recordLocator() {
            return this.$helpers.decryptText(this.recordLocatorHash);
        },
        typeList() {
            if (!this.trip) {
                return [];
            }
            return this.trip.tripSummary.typeList;
        },
        activeTripSegments() {
            return (this.trip.segments || []).filter(
                (segment) => segment.status !== "cancelled"
            );
        },
        travellerProfile() {
            return this.$store.getters[
                "travellersAndTrips/getCurrentTravellerProfile"
            ];
        },
        // We should only pass this once if user comes from trip detail page, not from back button
        getPreSelectedSegment() {
            if (!this.resetPreSelected) {
                return this.preSelectedSegment;
            } else {
                return null;
            }
        },
        tripTickets() {
            if (this.trip) {
                return this.trip.tickets;
            }
            return null;
        },
        isAuthorized() {
            if(this.trip){
                const loggedInAccountId = this.travellerProfile.account.id

                return loggedInAccountId === this.trip.account.salesforceId
            }
            return false;

        },
    },
};
</script>
<style>
ul {
    list-style-type: disc;
    margin-left: 25px;
}

.type-panel {
    border: 1px rgb(226, 223, 223) solid;
    border-radius: 6px;
}

.type-panel.isSelected {
    background: hsl(347, 90%, 96%);
}

.section-title {
    border-bottom: 1px solid #ddddde;
    padding: 24px 32px;
    position: relative;
    top: 1px;
}

.section-body {
    padding: 24px 32px;
    position: relative;
    top: 1px;
}

.panel-block:not(:last-child) {
    border-bottom: 1px solid #ddddde;
}
</style>